import { Api } from "../types/Api"

// 新闻列表
const getNewsList: Api = {
  url: "/news/v1/list",
  method: "get",
}
//新闻详情
const getNewsDetail: Api = {
  url: "/news/v1/detail",
  method: "get",
}
// 获取bannerlist
const getBannerList: Api = {
  url: "/news/v1/bannerList",
  method: "get",
}
// 访问量
const addCount: Api = {
  url: "/news/v1/addCount",
  method: "post",
}
// 验证码
const getCode: Api = {
  url: "/common/v1/captcha",
  method: "get",
}
// 证书查询
const queryCertificate: Api = {
  url: "/student/v1/queryCertificate",
  method: "get",
}
// systemUrl
const getSystemUrl: Api = {
  url: "/common/v1/systemUrl",
  method: "get",
}

// get config
const getConfig: Api = {
  url: "/common/v1/config",
  method: "get"
};

export {
  getNewsList,
  getNewsDetail,
  getBannerList,
  addCount,
  getCode,
  queryCertificate,
  getSystemUrl,
  getConfig
};
